import type { CSSProperties, ReactNode } from "react";
import { Card as ShadcnCard } from "@shadcn";
import { cn } from "../../../../utils/design-utils";

export type MetricCardTemplateProps = {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
  helperText?: ReactNode;
  helperClassName?: string;
  labelStyle?: CSSProperties;
};

export const MetricCardTemplate = ({
  label,
  value,
  icon,
  className = "",
  valueClassName = "",
  labelClassName = "metric-subtitle",
  helperText,
  helperClassName = "",
  labelStyle,
}: MetricCardTemplateProps): JSX.Element => {
  return (
    <ShadcnCard className={cn("p-6 min-h-[96px] border", className)}>
      <div className="flex items-center justify-between h-full">
        <div>
          <p className={cn("text-2xl font-bold text-neutral-darkest", valueClassName)}>
            {value}
          </p>
          <p className={cn(labelClassName)} style={labelStyle}>{label}</p>
          {helperText ? (
            <p className={cn("text-xs text-neutral-mediumDark mt-1", helperClassName)}>
              {helperText}
            </p>
          ) : null}
        </div>
        {icon ?? null}
      </div>
    </ShadcnCard>
  );
};
